// Single source of truth for public pricing. Rendered on /pricing and the
// how-it-works pricing section — keep them identical by editing only here.

export type PricingPlan = {
  /** Must match the billing catalog slug in infra/billing/stripe_plans.json. */
  slug: string
  name: string
  price: number
  subtitle: string
  features: string[]
  note: string
  cta: string
  featured?: boolean
}

export const PRICING_PLANS: PricingPlan[] = [
  {
    slug: "basic",
    name: "Basic",
    price: 29,
    subtitle: "For businesses getting started",
    features: ["SMS commands", "Invoice creation and sending", "Payment tracking", "1 phone operator"],
    note: "Data secured by Stripe (Bank-grade).",
    cta: "Start Basic",
  },
  {
    slug: "pro",
    name: "Pro",
    price: 49,
    subtitle: "For busy teams that need more",
    features: ["Everything in Basic", "Voice note input", "200 messages/month"],
    note: "Cancel anytime.",
    cta: "Start Pro",
    featured: true,
  },
  {
    slug: "premium",
    name: "Premium",
    price: 79,
    subtitle: "For solo operators who want it all",
    features: ["Everything in Pro", "Priority support", "Custom workflows", "API access"],
    note: "Custom workflows & API for owners who invoice on the move.",
    cta: "Start Premium",
  },
  {
    slug: "team",
    name: "Team",
    price: 149,
    subtitle: "For crews — everyone texts the same agent",
    features: [
      "Everything in Premium",
      "Up to 5 team members",
      "Overdue escalation sequences",
      "Priority phone support",
    ],
    note: "Each teammate gets their own line to the same agent. Extra seats $29/mo.",
    cta: "Start Team",
  },
]

export const PRICING_FAQ = [
  {
    question: "How are messaging costs handled?",
    answer: "We meter SMS usage monthly and pass through carrier fees with zero markup.",
  },
  {
    question: "What about refunds?",
    answer: "Refunds flow through Stripe and sync back to your dashboard instantly.",
  },
  {
    question: "How long do you keep data?",
    answer: "Chat transcripts persist 24 months by default; invoices are archived indefinitely for compliance.",
  },
  {
    question: "Can customers opt out?",
    answer: "Text STOP at any time. Your agent honors carrier opt-out lists and lets you know.",
  },
  {
    question: "Which regions are supported?",
    answer: "United States at launch. More geos unlock as carriers approve senders.",
  },
  {
    question: "Can I try it without a credit card?",
    answer: "Yes — 14-day free trial, and demo mode never touches your customers.",
  },
]
